export default __webpack_public_path__ + "132b3b4aab4710c458551a6d997b92a5.svg";